import classNames from "classnames";
import { Label, Typography } from "components/atoms";
import { TimeIndicatorIcon } from "components/atoms/Icon";
import { useScreenSize } from "hooks";
import "./index.scss";

interface IProps {
  title: string;
  text: string;
  isRead: boolean;
  labels?: string[];
  time?: string;
  onClick?: () => void;
}

export const NotificationBody = ({
  title,
  text,
  labels,
  isRead,
  time,
  onClick,
}: IProps) => {
  const screen = useScreenSize();

  const matchBgColor = (color: string) => {
    switch (color) {
      case "new":
        return "yellow";
      case "upcoming":
        return "gray";
      case "late":
        return "red";
      case "completed":
        return "green";
      case "viewed":
        return "pale-green";
      default:
        return "yellow";
    }
  };

  return (
    <div
      className={classNames(
        "message-wrapper",
        isRead ? "body-white" : "body-yellow"
      )}
      onClick={onClick}
    >
      <div className="title-wrapper">
        <div className="title">
          <Typography
            label={title}
            variant="h8Med"
            styles={screen.width <= 592 ? "custom-typography-style" : ""}
          />
        </div>
        <div className="time">
          <div className="duration">
            <Typography
              label={`${time}`}
              variant="h7Book"
              styles="typography-custom-style"
            />
          </div>
          {!isRead ? (
            <div className="indicator">
              <TimeIndicatorIcon />
            </div>
          ) : null}
        </div>
      </div>
      <div className="body-wrapper">
        <Typography
          label={text}
          variant="h8Book"
          styles={screen.width <= 592 ? "custom-typography-style" : ""}
        />
      </div>
      <div className="label-section">
        {labels?.map((item: any) => (
          <Label
            label={item.Label}
            styles="custom-label-style"
            dynamicBackgroundColor={item.Color}
          />
        ))}
      </div>
    </div>
  );
};
